import _ from '@lodash';
import TablePagination from '@fuse/components/general/TablePagination';
import Typography from '@material-ui/core/Typography';
import { motion } from 'framer-motion';
import { withRouter } from 'react-router-dom';
import FuseLoading from '@fuse/core/FuseLoading';
import { makeStyles } from '@material-ui/core/styles';
import ListView from './listView';
import useRouter from '@fuse/hooks/useRouter';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';

const useStyles = makeStyles({
	layoutRoot: {},
	head: {
		position: "sticky",
		top: 0
	},
	root: {
		// minWidth: 275,
	},
	title: {
		fontSize: 14,
	},
	pos: {
		marginBottom: 12,
	},
});

function EndUsersAccountsTable(props) {

	if (!props.viewServiceRequestPermission) {
		return (
			<div>
				<Card>
					<CardContent>You don't have permission to view any Service Tickets at this time. Please contact your Systems Administrator for access.</CardContent>
				</Card>
			</div>
		)
	}

	return (
		<div className="w-full flex flex-col">
			<SwitchView
				viewServiceRequestPermission = {props.viewServiceRequestPermission}
				createServiceRequestPermission = {props.createServiceRequestPermission}
				updateServiceRequestPermission = {props.updateServiceRequestPermission}
				deleteServiceRequestPermission = {props.deleteServiceRequestPermission}
			/>
		</div>
	);

}

function SwitchView({
	viewServiceRequestPermission, createServiceRequestPermission,
	updateServiceRequestPermission, deleteServiceRequestPermission
}) {
	return(
		<ListView
			viewServiceRequestPermission = {viewServiceRequestPermission}
			createServiceRequestPermission = {createServiceRequestPermission}
			updateServiceRequestPermission = {updateServiceRequestPermission}
			deleteServiceRequestPermission = {deleteServiceRequestPermission}
		/>
	)
}

export default withRouter(EndUsersAccountsTable)
